export const environment = {
  production: true,
  qa: false,
  downloadsBaseURL: 'https://developer.gm.com/downloads',
  serviceURL: 'https://developer.gm.com/server',
  clientId: '39a89d87-41ee-4ed6-9b98-55f52e0936ee',
  analytics_script: '//assets.adobedtm.com/81e75e0d225e65a4860f48466627a6b696b9fc66/satelliteLib-903b89fd3f14244058d8cb4a408cf57d3db38f73.js',
  adobe_bottom_script: 'adobe-dtm-bottom.js',
  azure_tenant: 'gmapideveloper.onmicrosoft.com',
  azure_instance: 'https://login.developer.gm.com/',
  azure_default_parameter: 'p=B2C_1_DeveloperPortal_SignInPolicy&scope=openid',
  azure_profile_edit_parameter: 'p=B2C_1_DeveloperPortal_ProfileEdit&scope=openid',
  azure_password_reset_paramter: 'p=B2C_1_DeveloperPortal_PasswordReset&scope=openid'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts